<!-- LOADING STATE -->
@if (loading()) {
  <div class="container py-5 text-center">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">{{ 'COMMON.loading' | translate }}</span>
    </div>
  </div>
}

<!-- ERROR STATE -->
@else if (error()) {
  <div class="container py-5 text-center">
    <div class="alert alert-danger" role="alert">
      {{ error() | translate }}
    </div>
    <a routerLink="/browse-index" class="btn btn-outline-secondary mt-3">{{ 'indexDetails.returnToIndex' | translate }}</a>
  </div>
}

<!-- MAIN CONTENT -->
@else if (biblio(); as b) {
  <app-bread-crump
    [title]="translate.currentLang === 'en' ? (b.titleEN || b.title) : (b.titleAR || b.title)"
    [description]="b.abstract || ''"
    [items]="[
      { label: ('Nav.Home' | translate), url: '/home' },
      { label: ('Nav.libraries' | translate), url: '/libraries' },
      { label: ('Nav.biblios' | translate), url: '/browse-index' },
      { label: (translate.currentLang === 'en' ? (b.titleEN || b.title) : (b.titleAR || b.title)) }
    ]">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 w-100 mt-3">
      <p class="mb-0 text-muted" *ngIf="b.barcode">{{ 'indexDetails.barcode' | translate }}: {{ b.barcode }}</p>
            <div class="d-flex gap-3 align-items-center">
              <button class="btn_secondary" *ngIf="b.files && b.files.length > 0" (click)="viewFile(b.files[0].filePath)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <span>{{ 'indexDetails.viewFile' | translate }}</span>
              </button>
              <a class="btn-primary text-decoration-none" *ngIf="b.files && b.files.length > 0" [href]="getFileUrl(b.files[0].filePath)" target="_blank" download>
                <span>{{ 'indexDetails.download' | translate }}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 15.75C20.4142 15.75 20.75 16.0858 20.75 16.5C20.75 17.1367 20.7182 17.699 20.6133 18.1768C20.5065 18.663 20.3137 19.1081 19.9609 19.4609C19.6081 19.8137 19.163 20.0065 18.6768 20.1133C18.199 20.2182 17.6367 20.25 17 20.25H7C6.36332 20.25 5.80097 20.2182 5.32324 20.1133C4.837 20.0065 4.39187 19.8137 4.03906 19.4609C3.68626 19.1081 3.49354 18.663 3.38672 18.1768C3.28178 17.699 3.25 17.1367 3.25 16.5C3.25 16.0858 3.58579 15.75 4 15.75C4.41421 15.75 4.75 16.0858 4.75 16.5C4.75 17.104 4.78286 17.5371 4.85254 17.8545C4.92041 18.1634 5.01266 18.3134 5.09961 18.4004C5.18656 18.4873 5.33657 18.5796 5.64551 18.6475C5.96291 18.7171 6.39595 18.75 7 18.75H17C17.604 18.75 18.0371 18.7171 18.3545 18.6475C18.6634 18.5796 18.8134 18.4873 18.9004 18.4004C18.9873 18.3134 19.0796 18.1634 19.1475 17.8545C19.2171 17.5371 19.25 17.104 19.25 16.5C19.25 16.0858 19.5858 15.75 20 15.75ZM12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V12.9619C12.7519 12.9596 12.7539 12.9574 12.7559 12.9551C12.9665 12.7064 13.1733 12.443 13.3662 12.1973C13.3811 12.1783 13.3964 12.1594 13.4111 12.1406C13.6032 11.8961 13.8049 11.6391 13.9619 11.4775C14.2505 11.1806 14.7254 11.1735 15.0225 11.4619C15.3194 11.7505 15.3265 12.2254 15.0381 12.5225C14.9494 12.6137 14.803 12.796 14.5898 13.0674C14.5745 13.0869 14.5588 13.1068 14.543 13.127C14.3529 13.3691 14.1301 13.6537 13.9004 13.9248C13.6544 14.2151 13.3788 14.5165 13.1035 14.751C12.9656 14.8684 12.8098 14.9847 12.6426 15.0742C12.4811 15.1606 12.2583 15.25 12 15.25C11.7417 15.25 11.5189 15.1606 11.3574 15.0742C11.1902 14.9847 11.0344 14.8684 10.8965 14.751C10.6212 14.5165 10.3456 14.2151 10.0996 13.9248C9.86988 13.6537 9.6471 13.3691 9.45703 13.127C9.44119 13.1068 9.42552 13.0869 9.41016 13.0674C9.19696 12.796 9.05062 12.6137 8.96191 12.5225C8.67349 12.2254 8.68061 11.7505 8.97754 11.4619C9.27458 11.1735 9.74948 11.1806 10.0381 11.4775C10.1951 11.6391 10.3968 11.8961 10.5889 12.1406C10.6036 12.1594 10.6189 12.1783 10.6338 12.1973C10.8267 12.443 11.0335 12.7064 11.2441 12.9551C11.2461 12.9574 11.2481 12.9596 11.25 12.9619V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z"
                    fill="white" />
                </svg>
              </a>
            </div>
    </div>
  </app-bread-crump>

  <!-- OPTIONAL PDF EMBED -->
  <div class="pdf my-4" *ngIf="pdfUrl()">
    <app-flipbook [pdfUrl]="pdfUrl()!"></app-flipbook>
  </div>

  <!-- INDEXING CARD / TABLE -->
  <div class="index">
    <div class="container">
      <h3>{{ 'indexDetails.indexingCard' | translate }}</h3>
      <div class="content">
        <div class="table-responsive w-100">
          <table class="table">
            <tr *ngIf="b.barcode">
              <td>{{ 'indexDetails.barcode' | translate }}</td>
              <td>{{ b.barcode }}</td>
            </tr>
            <tr *ngIf="b.savedNumber">
              <td>{{ 'indexDetails.savedNumber' | translate }}</td>
              <td>{{ b.savedNumber }}</td>
            </tr>
            <tr *ngIf="b.codeNumber">
              <td>{{ 'indexDetails.codeNumber' | translate }}</td>
              <td>{{ b.codeNumber }}</td>
            </tr>
            <tr *ngIf="b.author">
              <td>{{ 'indexDetails.author' | translate }}</td>
              <td class="text-success">{{ b.author }}</td>
            </tr>
            <tr *ngIf="b.calligrapherName">
              <td>{{ 'indexDetails.calligrapher' | translate }}</td>
              <td class="text-success">{{ b.calligrapherName }}</td>
            </tr>
            <tr>
              <td>{{ 'indexDetails.language' | translate }}</td>
              <td>{{ b.language ?? ('indexDetails.arabic' | translate) }}</td>
            </tr>
            <tr *ngIf="b.publicationPlace || b.publicationYear || b.hijriDate">
              <td>{{ 'indexDetails.publicationDateAndPlace' | translate }}</td>
              <td>{{ b.publicationPlace }} {{ b.hijriDate ?? b.publicationYear }}</td>
            </tr>
            <tr *ngIf="b.pages">
              <td>{{ 'indexDetails.physicalDescription' | translate }}</td>
              <td>{{ b.pages }} {{ 'indexDetails.page' | translate }}</td>
            </tr>
            <tr *ngIf="b.notes">
              <td>{{ 'indexDetails.notes' | translate }}</td>
              <td>{{ b.notes }}</td>
            </tr>
            <tr *ngIf="b.library">
              <td>{{ 'indexDetails.affiliatedLibrary' | translate }}</td>
              <td class="text-success">{{ b.library }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>


  <!-- RELATED MATERIALS -->
  <div class="matrial">
    <div class="container">
      <div class="section-header">
        <h2>{{ 'indexDetails.otherMaterials' | translate }}</h2>
        <a routerLink="/browse-index" class="btn_secondary btn-view-all">{{ 'indexDetails.viewAll' | translate }}</a>
      </div>

      <div class="global-cards-row home mobile-scroll-row mt-4">
        <div class="global-cards-row__container" *ngFor="let item of relatedItems()">
          <app-index-card [item]="item"></app-index-card>
        </div>
      </div>
    </div>
  </div>
}

<app-footer></app-footer>
